import { Injectable } from '@angular/core';
declare global {
  interface Window {
    scSdkId?: string;
    scLayer?: any[];
    scq?: (eventName: string, eventType: string, p?: any) => void;
  }
}
@Injectable({
  providedIn: 'root'
})
export class ShareChatTrackingService {

  initializeTracking(sdkId: string): void {
  window.scSdkId = sdkId;
  window.scLayer = window.scLayer || [];

  window.scq = (eventName: string, eventType: string, p?: any) => {
    const props = p || {};
    window.scLayer!.push({
      eventName: eventName,
      eventType: eventType,
      meta: props,
      eventFireTs: Date.now()
    });
  };

  const scr = document.createElement('script');
  scr.type = 'text/javascript';
  scr.async = true;
  scr.src = 'https://sc-events-sdk.sharechat.com/web-sdk.js';

  scr.onload = () => {
    window.scq!("PAGE_VIEW", "AUTO", {
      pageUrl: window.location.href
    });
  };

  const x = document.getElementsByTagName('script')[0];
  x.parentNode!.insertBefore(scr, x);
}
  

  sendCustomEvent(eventName: string, eventType: string, props?: any): void {
    if (typeof window['scq'] === 'function') {
      window['scq'](eventName, eventType, props);
    } else {
      console.error("scq function is not available on the window object.");
    }
  }
  
}